import React from 'react';
import { Trans } from 'react-i18next';
import cx from 'classnames';

import css from './cardMask.module.sass';

interface Props {
  mask: string;
  className?: string;
}

export const CardMask: React.FC<Props> = ({ mask, className }) => {
  return (
    <p className={cx(css.root, className)}>
      <Trans
        i18nKey="cardMask"
        ns="common"
        values={{
          mask,
        }}
      />
    </p>
  );
};
